import { encodeOpts as paramsSerializer } from '@/utils/encode-opts';

const categoriesApiFactory = (axios) => ({
  getCategory: async (slug, params = {}) => (await axios.get(`/categories/${slug}`, { params, paramsSerializer })).data, //all-products
});

export { categoriesApiFactory };
